import { LoadableBackground } from '@confluence/loadable';

export const GeneralShortcutListener = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GeneralShortcutListener" */ '../src/GeneralShortcutListener'
			)
		).GeneralShortcutListener,
});
